import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CopyToClipboard from 'react-copy-to-clipboard';

import { PathName } from 'appConstants';
import { profileSelectors } from 'store/profile/selectors';

import { TitleText, toastSuccess } from 'components';
import { WhiteContainer } from 'containers';

import { copyIcon, redirectIcon } from 'assets/images';
import styles from './styles.module.scss';

export const ReferralCodeContainer = () => {
  const { t } = useTranslation('partner');
  const { referralCode } = useSelector(profileSelectors.getState);
  const isHost = window.location.host.includes('test');

  const baseURL = isHost ? PathName.AppUrlTest : PathName.AppUrl;
  const mainURL = isHost ? PathName.AppMainUrlTest : PathName.AppMainUrl;
  const hubURL = isHost ? PathName.AppHubUrlTest : PathName.AppHubUrl;

  const onCopy = useCallback(() => {
    toastSuccess(t('Copy_code_'));
  }, [t]);

  const onOpen = useCallback((link:string) => {
    window.open(link, '_blank');
  }, []);

  const linkContainer = useMemo(() => [
    {
      id: 1,
      title: t('Referral_code_1_'),
      referralLink: `${baseURL}?ref=${referralCode}`,
      btnText: t('Copy_'),
      btnCallback: onCopy,
      btnIcon: copyIcon,
    },
    {
      id: 2,
      title: t('Referral_code_2_'),
      referralLink: `${mainURL}/?ref=${referralCode}`,
      btnText: t('Copy_'),
      btnCallback: onCopy,
      btnIcon: copyIcon,
    },
    {
      id: 3,
      title: t('Referral_code_3_'),
      referralLink: `${hubURL}/?ref=${referralCode}&self=true`,
      btnText: t('Open_HUB_'),
      btnCallback: onOpen,
      btnIcon: redirectIcon,
    },
  ], [baseURL, hubURL, mainURL, onCopy, onOpen, referralCode, t]);

  return (
    <div className={styles.partner_container}>
      <TitleText text={t('My_referral_code_')} />
      <WhiteContainer className={styles.partner_content}>
        {linkContainer?.map((linkItem) => (
          <div
            className={styles.partner_copy_link_container}
            key={linkItem?.id}
          >
            <div className={styles.partner_copy_label_container}>
              <span>{linkItem?.title}</span>
              <p>{linkItem?.referralLink}</p>
            </div>

            {linkItem?.id === 3 
              ? (
                <div
                  className={styles.partner_copy_btn}
                  onClick={() => onOpen(linkItem?.referralLink)}
                  aria-hidden="true"
                >
                  {linkItem?.btnText}
                  <img 
                    src={linkItem?.btnIcon}
                    alt=""
                  />
                </div>
              )
              : (
                <CopyToClipboard
                  text={linkItem?.referralLink || ''}
                  onCopy={linkItem?.btnCallback}
                >
                  <div className={styles.partner_copy_btn}>
                    {linkItem?.btnText}
                    <img 
                      src={linkItem?.btnIcon}
                      alt=""
                    />
                  </div>
                </CopyToClipboard>
              )}
          
          </div>
        ))}
      </WhiteContainer>
    </div>
  );
};
